// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","size252":"252px","meetingDateTimeInfo":"meeting-date-time-info__meetingDateTimeInfo___ACpbQ"};